import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";
import { EntityId, IRoleEdit, IUser } from "src/app/interfaces";
import { NotificationFacade } from "src/app/notifications/services/notification.facade";
import { NavigationService } from "src/app/services/navigation.service";
import { SubSink } from "subsink";
import { UserFacade } from "../services/user.facade";

@Component({
    selector: "admin-edit-user-role",
    templateUrl: "./admin-edit-user-role.html",
    standalone: false
})
export class AdminEditUserRoleComponent implements OnInit, OnDestroy {
  public roles: IRoleEdit[];
  private subSink = new SubSink();
  public user$: Observable<IUser>;
  private userId: EntityId;
  constructor(
    private facade: UserFacade,
    private navigate: NavigationService,
    private route: ActivatedRoute,
    private notificationFacade: NotificationFacade
  ) {}
  ngOnInit(): void {
    this.subSink.sink = this.facade
      .getUserIdFromRoute(this.route)
      .subscribe((x) => {
        this.userId = x;
        this.user$ = this.facade.getUser(x);
        this.subSink.sink = this.facade
          .getUserRole(x)
          .subscribe((role) => (this.roles = role));
      });
  }

  public goBack() {
    this.navigate.back();
  }

  save() {
    this.facade.saveUserRoles(this.userId, this.roles).subscribe(() => {
      this.notificationFacade.success("role.component.user.save.success");
      this.goBack();
    });
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
